<template>
  <div class="animated fadeIn">
    <div class="table-container">
      <div class="list-wrapper">
        <div>
          <div class="j_datagrid__header type01">
            <div class="header__title">
              <h5>
                {{ $store.state.sysenv.codePropagated.name }}
                <small>{{ $store.state.sysenv.codePropagated.parentName }}</small>
              </h5>
            </div>

            <div class="header__right">
              <v-flex>
                <button class="jcon_add" @click="setAdd"></button>
                <div class="j_search type01">
                  <input v-model="search" type="search" name="q" placeholder="Filter and search" />
                  <button type="submit">
                    <v-icon>mdi-magnify</v-icon>
                  </button>
                </div>
              </v-flex>
            </div>
          </div>

          <j-data-grid
            v-model="selected"
            hide-actions
            :headers="headers"
            :items="items"
            :search="search"
          >
            <template v-slot:items="props">
              <tr :active="props.selected" @click="propStatus(props)">
                <td style="text-align: center">{{ props.item.no }}</td>
                <td style="text-align: center">{{ props.item.idx }} / {{ props.item.navIdx }}</td>
                <td v-if="!phaseAppreared">{{ props.item.phaseName }}</td>
                <td v-if="!phaseAppreared">{{ props.item.groupName }}</td>
                <td>{{ props.item.itemName }}</td>
                <td>{{ props.item.subItemName }}</td>
                <td>{{ props.item.name }}</td>
                <td style="text-align: center">{{ props.item.catCode }}</td>
                <td>{{ props.item.desc }}</td>
              </tr>
            </template>
          </j-data-grid>
        </div>
      </div>

      <form-modal 
        v-model="formOpened"
        :item-key="itemKey"
        @updated="onUpdated"
      />
    </div>
  </div>
</template>

<script>
import { PageComponentService } from '@/services'
import FormModal from './modal/SysenvPageDashboard.modal'

export default {
  name: 'sysenv-dashboard',
  components: {
    FormModal
  },
  data: () => ({
    pageComponentService: null,
    formOpened: false,
    search: '',
    selected: [],
    selectedItem: {},
    selectedPrevItem: [],
    items: [],
    itemKey: null
  }),
  watch: {
    codePropagated: {
      handler(val) {
        this.getDashboardItems()
      },
      deep: true
    },
    formOpened(val) {
      if(!val) this.itemKey = null
    }
  },
  created() {
    this.pageComponentService = new PageComponentService()
  },
  computed: {
    codePropagated: {
      get() { return this.$store.state.sysenv.codePropagated },
      set(val) { this.$store.commit('sysenv/codePropagate', val) }
    },
    headers() {
      let headers_ = [
        { type: 'conf', text: 'No', align: 'center', value: 'no', sortable: false, width: 40, },
        { type: 'text', text: 'IDX', align: 'center', value: 'idx', sortable: false, width: 80, },
      ]
      if(!this.phaseAppreared) headers_ = [
        ...headers_,
        { type: 'text', text: 'Phase', value: 'phaseName', sortable: false, width: 150, },
        { type: 'text', text: 'Menu Group', value: 'groupName', sortable: false, width: 180, },
      ]
      headers_ = [
        ...headers_,
        { type: 'text', text: 'Menu Item', value: 'itemName', sortable: false, width: 210, },
        { type: 'text', text: 'Sub-Item', value: 'subItemName', sortable: false, width: 150, },
        { type: 'text', text: 'Title', value: 'name', sortable: false, width: 270, },
        { type: 'text', text: 'Type', align: 'center', value: 'typeCode', sortable: false, width: 80, },
        { type: 'text', text: 'Desciption', value: 'desc', sortable: false },
      ]
      return headers_
    },
    
    phaseAppreared() { return this.codePropagated.parentCode != 'ALL'},
    itemAppreared() { return this.codePropagated.code != 'ALL'},
  },
  methods: {
    getDashboardItems() {
      this.pageComponentService.getDashboardItems(
        this.codePropagated.parentCode,
        this.codePropagated.groupCode,
        this.codePropagated.code,
        'ALL',
        'ALL',
        this.setDashboardItem,
      )
    },
    setDashboardItem(res) {
      if (!res) res = []
      this.items = res
    },
    setAdd() {
      this.itemKey = ''
      this.selectedItem = {}
      this.selectedItem.idx = ''
      this.formOpened = true
    },
    propStatus(props) {
      this.selectedItem = Object.assign({}, props.item)
      this.itemKey = this.selectedItem.idx

      if (this.selectedPrevItem.length > 0) {
        if (this.selectedPrevItem[0].idx == props.item.idx) {
          this.formOpened = true
          return
        } else {
          let _selected = props.item
          this.selected = [_selected]
        }
      } else {
        props.selected = !props.selected
      }
      this.selectedPrevItem = [...this.selected]
      this.formOpened = true
    },
    onUpdated() {
      this.getDashboardItems()
    }
  },
}
</script>
